import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminContext } from '../../contexts/AdminContext';

const CONTENT_TYPES = [
  { type: 'portrait', label: 'Portrait', description: 'Anwalts-Biografie und Profil' },
  { type: 'faq', label: 'FAQ', description: 'Häufig gestellte Fragen nach Kategorie' },
  { type: 'glossary', label: 'Glossar', description: 'Juristische Begriffe und Erklärungen' },
  { type: 'blog', label: 'Blog', description: 'Blogbeiträge und Artikel' },
  { type: 'impressum', label: 'Impressum', description: 'Rechtliche Informationen' },
  { type: 'settings', label: 'Einstellungen', description: 'Datenschutz-, AGB- und Widerrufslinks' },
];

const AdminDashboard: React.FC = () => {
  const { newInquiriesCount, updatedInquiriesCount } = useAdminContext();

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {CONTENT_TYPES.map((ct) => (
          <Link
            key={ct.type}
            to={`/admin/${ct.type}`}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition group"
          >
            <h3 className="text-lg font-semibold text-primary-700 group-hover:text-primary-500 transition">
              {ct.label}
            </h3>
            <p className="text-sm text-gray-500 mt-2">{ct.description}</p>
          </Link>
        ))}
        <Link
          to="/admin/media"
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition group"
        >
          <h3 className="text-lg font-semibold text-primary-700 group-hover:text-primary-500 transition">
            Media
          </h3>
          <p className="text-sm text-gray-500 mt-2">Bilder und Dateien verwalten</p>
        </Link>
        <Link
          to="/admin/inquiries"
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition group"
        >
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-primary-700 group-hover:text-primary-500 transition">
              Kontaktanfragen
            </h3>
            <span className="flex gap-1">
              {newInquiriesCount > 0 && (
                <span className="bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 min-w-[1.5rem] text-center">
                  {newInquiriesCount}
                </span>
              )}
              {updatedInquiriesCount > 0 && (
                <span className="bg-blue-500 text-white text-xs font-bold rounded-full px-2 py-0.5 min-w-[1.5rem] text-center">
                  {updatedInquiriesCount}
                </span>
              )}
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-2">Eingegangene Kontaktformular-Nachrichten</p>
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
